import queryString from 'qs';

export const getParentAccountRequest = (queryParams) => {
  const queries = {
    accountTypeId: 1,
    ecommerce: 'id=1',
  };

  if (queryParams?.brand) queries['brands.name'] = queryParams?.brand?.value;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getParentAccountRequest;
